export enum ECloudProvider {
  AWS = 1,
  Azure = 2,
}

export const CloudProviderMapping = {
  [ECloudProvider.AWS]: "AWS",
  [ECloudProvider.Azure]: "Azure",
};

export interface AssessmentHostsForCloud {
  buffer: number;
  cloudProvider: ECloudProvider;
  //0 - 100
  headroom: number;
  hostList: string;
  //server;server2..
  percentile: 90 | 97; //0-20
  redFlagBuffering: number; // 0-100
  useLocalDriveForTempDB: "Yes" | "No";
  hosts?: any;
}

export enum AssessHostsForCloudResultType {
  File = 1,
  Data = 2,
}

interface ComputationParameter {
  parameter: string;
  value: string;
}

interface ComputationParametersTitle {
  title: string;
}

interface ServerProfilesTitle {
  title: string;
}

interface ServerProfile {
  cpuSockets: number;
  cpuUsage: number;
  databases: string;
  diskSize: number;
  logicalCores: number;
  machineModel: string;
  memory: number;
  memoryUsage: number;
  physicalCores: number;
  processor: string;
  readPercentage: number;
  redFlaggedResources: string;
  server: string;
  serverVersionEdition: string;
  sqlEdition: string;
  sqlInstances: string;
  sqlVersion: string;
  totalIOPS: number;
  totalMBPerSec: number;
  type: string;
}

interface EC2PlacementTitle {
  title: string;
}

interface EC2Placement {
  cloudMachine: string;
  computeAnnualCost: string;
  cores: number;
  memory: string;
  server: string;
  sqlEdition: string;
  sqlInstances: string;
  storage: string;
  storageAnnualCost: string;
}

interface AssessmentSummary {
  computeAnnualCost: number;
  cores: number;
  location?: "On Prem" | "Cloud" | "Diff %";
  memoryGB: number;
  storageAnnualCost: number;
  storageSizeGB: number;
}

export interface Assessment {
  assessmentSummary: AssessmentSummary[];
  computationParameters: ComputationParameter[];
  computationParametersTitle: ComputationParametersTitle[];
  eC2Placement: EC2Placement[];
  eC2PlacementTitle: EC2PlacementTitle[];
  serverProfiles: ServerProfile[];
  serverProfilesTitle: ServerProfilesTitle[];
}
